/* ============================================================
   TINY MAIL STUDIO — SHOPIFY THEME JS
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  // ── MOBILE NAV ────────────────────────────────────────────
  const hamburger = document.querySelector('.nav-hamburger');
  const drawer = document.querySelector('.mobile-nav-drawer');
  const overlay = document.querySelector('.mobile-nav-overlay');
  const closeBtn = document.querySelector('.mobile-nav-close');

  function openNav() {
    drawer?.classList.add('open');
    overlay?.classList.add('visible');
    hamburger?.setAttribute('aria-expanded', 'true');
    drawer?.setAttribute('aria-hidden', 'false');
  }
  function closeNav() {
    drawer?.classList.remove('open');
    overlay?.classList.remove('visible');
    hamburger?.setAttribute('aria-expanded', 'false');
    drawer?.setAttribute('aria-hidden', 'true');
  }

  hamburger?.addEventListener('click', openNav);
  closeBtn?.addEventListener('click', closeNav);
  overlay?.addEventListener('click', closeNav);

  // ── SCROLL REVEAL ─────────────────────────────────────────
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    reveals.forEach(el => observer.observe(el));
  } else {
    reveals.forEach(el => el.classList.add('visible'));
  }

  // ── ORDER FORM ────────────────────────────────────────────
  const accordion = document.getElementById('person-accordion');
  if (!accordion) return; // Not on a page with the order form

  const PERSON_COUNT = 8;

  // Build person accordion cards
  for (let i = 1; i <= PERSON_COUNT; i++) {
    const card = document.createElement('div');
    card.className = 'person-card';
    card.id = 'person-' + i;
    card.innerHTML = `
      <div class="person-header" onclick="TMS.togglePerson(${i})" role="button" aria-expanded="false" aria-controls="person-body-${i}">
        <div class="person-header-left">
          <div class="person-number">${i}</div>
          <div>
            <div class="person-header-title">Special Person #${i}</div>
            <div class="person-header-preview" id="person-${i}-preview">Not yet filled in</div>
          </div>
        </div>
        <span class="person-chevron" aria-hidden="true">▼</span>
      </div>
      <div class="person-body" id="person-body-${i}">
        <div class="field-row">
          <div class="field-group">
            <label class="field-label" for="p${i}-first">First Name</label>
            <input class="f-input" id="p${i}-first" placeholder="First name" oninput="TMS.updatePersonPreview(${i})">
          </div>
          <div class="field-group">
            <label class="field-label" for="p${i}-last">Last Name</label>
            <input class="f-input" id="p${i}-last" placeholder="Last name" oninput="TMS.updatePersonPreview(${i})">
          </div>
        </div>
        <div class="field-group">
          <label class="field-label" for="p${i}-street1">Street Address</label>
          <input class="f-input" id="p${i}-street1" placeholder="Street address" style="margin-bottom:0.5rem">
          <input class="f-input" id="p${i}-street2" placeholder="Apt, Suite (optional)">
        </div>
        <div class="field-row">
          <div class="field-group"><label class="field-label" for="p${i}-city">City</label><input class="f-input" id="p${i}-city" placeholder="City"></div>
          <div class="field-group" style="max-width:100px"><label class="field-label" for="p${i}-state">State</label><input class="f-input" id="p${i}-state" placeholder="State"></div>
          <div class="field-group" style="max-width:110px"><label class="field-label" for="p${i}-zip">ZIP</label><input class="f-input" id="p${i}-zip" placeholder="ZIP"></div>
        </div>
        <div class="field-group" style="margin-top:0.6rem">
          <label class="field-label">Photo Upload</label>
          <div class="photo-upload-zone" id="pzone-${i}" onclick="document.getElementById('pfile-${i}').click()">
            <input type="file" id="pfile-${i}" accept="image/*" style="display:none" onchange="TMS.handlePhoto(${i}, this)">
            <div class="photo-preview-circle" id="pcirc-${i}"><img id="pimg-${i}" src="" alt=""></div>
            <div class="photo-upload-icon" id="picon-${i}">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#5A8099" stroke-width="1.5" stroke-linecap="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
            </div>
            <p id="pzone-txt-${i}">Click or drag to upload a photo<br><span style="font-size:0.72rem;color:#9AAAB5">JPG, PNG, WEBP · Will be cropped to circle</span></p>
          </div>
        </div>
      </div>`;
    accordion.appendChild(card);
  }

  // Open first person by default
  TMS.togglePerson(1);

  // Kit selector
  document.querySelectorAll('.kit-option').forEach(opt => {
    opt.addEventListener('click', () => {
      document.querySelectorAll('.kit-option').forEach(o => o.classList.remove('selected'));
      opt.classList.add('selected');
    });
  });

  // Confirm checks
  document.querySelectorAll('.confirm-check').forEach(chk => {
    chk.addEventListener('click', () => {
      const checked = chk.classList.toggle('checked');
      const box = chk.querySelector('.check-box');
      if (box) box.textContent = checked ? '✓' : '';
    });
  });

  // Init stepper
  TMS.goToStep(0);

}); // end DOMContentLoaded

// ── TMS NAMESPACE (called from inline handlers) ───────────────
window.TMS = (() => {
  let currentStep = 0;
  const totalSteps = 4;
  const PERSON_COUNT = 8;

  function togglePerson(n) {
    const card = document.getElementById('person-' + n);
    if (!card) return;
    const wasOpen = card.classList.contains('open');
    card.classList.toggle('open');
    const header = card.querySelector('.person-header');
    if (header) header.setAttribute('aria-expanded', String(!wasOpen));
  }

  function updatePersonPreview(n) {
    const first = document.getElementById('p' + n + '-first')?.value.trim() || '';
    const last = document.getElementById('p' + n + '-last')?.value.trim() || '';
    const preview = document.getElementById('person-' + n + '-preview');
    const card = document.getElementById('person-' + n);
    const name = [first, last].filter(Boolean).join(' ');
    if (preview) preview.textContent = name || 'Not yet filled in';
    if (card) card.classList.toggle('filled', !!name);
  }

  function handlePhoto(n, input) {
    const file = input.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = e => {
      const img = document.getElementById('pimg-' + n);
      const circ = document.getElementById('pcirc-' + n);
      const icon = document.getElementById('picon-' + n);
      const txt = document.getElementById('pzone-txt-' + n);
      if (img) img.src = e.target.result;
      if (circ) circ.style.display = 'block';
      if (icon) icon.style.display = 'none';
      if (txt) txt.innerHTML = file.name + '<br><span style="font-size:0.72rem;color:#8A9260">✓ Photo uploaded — click to change</span>';
    };
    reader.readAsDataURL(file);
  }

  function goToStep(n) {
    document.querySelectorAll('.form-card').forEach((c, i) => {
      c.classList.toggle('active', i === n);
    });
    document.querySelectorAll('.step-dot').forEach((d, i) => {
      d.classList.remove('active', 'done');
      const circle = d.querySelector('.step-dot-circle');
      if (i < n) { d.classList.add('done'); if (circle) circle.textContent = '✓'; }
      else if (i === n) { d.classList.add('active'); if (circle) circle.textContent = i + 1; }
      else { if (circle) circle.textContent = i + 1; }
    });
    for (let i = 0; i < totalSteps - 1; i++) {
      const conn = document.getElementById('conn-' + i);
      if (conn) conn.classList.toggle('done', i < n);
    }
    currentStep = n;
    if (n === 3) buildReviewSummary();
    const formTop = document.getElementById('order-form');
    if (formTop) window.scrollTo({ top: formTop.offsetTop - 80, behavior: 'smooth' });
  }

  function nextStep(from) {
    if (from === 0 && !validateStep0()) return;
    if (from === 1 && !validateStep1()) return;
    if (from < totalSteps - 1) goToStep(from + 1);
  }

  function prevStep(from) {
    if (from > 0) goToStep(from - 1);
  }

  function validateStep0() {
    let ok = true;
    ['parent-first','parent-last','order-number','parent-email'].forEach(id => {
      const el = document.getElementById(id);
      if (!el) return;
      if (!el.value.trim()) { el.classList.add('error'); ok = false; }
      else el.classList.remove('error');
    });
    if (!document.querySelector('.kit-option.selected')) {
      const opts = document.querySelector('.kit-options');
      if (opts) { opts.style.outline = '1.5px solid #BE7F7F'; opts.style.borderRadius = '3px'; }
      ok = false;
    } else {
      const opts = document.querySelector('.kit-options');
      if (opts) opts.style.outline = '';
    }
    return ok;
  }

  function validateStep1() {
    let ok = true;
    ['child-first','child-last','child-age','child-street1','child-city','child-state','child-zip'].forEach(id => {
      const el = document.getElementById(id);
      if (!el) return;
      if (!el.value.trim()) { el.classList.add('error'); ok = false; }
      else el.classList.remove('error');
    });
    return ok;
  }

  function buildReviewSummary() {
    const kit = document.querySelector('.kit-option.selected');
    const kitName = kit ? kit.querySelector('.kit-name')?.textContent : '—';
    const pFirst = document.getElementById('parent-first')?.value || '';
    const pLast = document.getElementById('parent-last')?.value || '';
    const cFirst = document.getElementById('child-first')?.value || '';
    const cLast = document.getElementById('child-last')?.value || '';
    const cAge = document.getElementById('child-age')?.value || '';
    const addr = [
      document.getElementById('child-street1')?.value,
      document.getElementById('child-street2')?.value,
      [document.getElementById('child-city')?.value,
       document.getElementById('child-state')?.value,
       document.getElementById('child-zip')?.value].filter(Boolean).join(', ')
    ].filter(Boolean).join(', ');

    const people = [];
    for (let i = 1; i <= PERSON_COUNT; i++) {
      const f = document.getElementById('p' + i + '-first')?.value.trim() || '';
      const l = document.getElementById('p' + i + '-last')?.value.trim() || '';
      if (f || l) people.push((f + ' ' + l).trim());
    }

    const div = document.getElementById('review-summary');
    if (!div) return;
    div.innerHTML = `
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:1rem;">
        <div><div style="font-size:0.7rem;letter-spacing:0.12em;text-transform:uppercase;color:var(--text-light);margin-bottom:4px">Parent</div><strong style="color:var(--text-dark)">${pFirst} ${pLast}</strong></div>
        <div><div style="font-size:0.7rem;letter-spacing:0.12em;text-transform:uppercase;color:var(--text-light);margin-bottom:4px">Order Number</div><strong style="color:var(--text-dark)">${document.getElementById('order-number')?.value || ''}</strong></div>
        <div><div style="font-size:0.7rem;letter-spacing:0.12em;text-transform:uppercase;color:var(--text-light);margin-bottom:4px">Kit</div><strong style="color:var(--text-dark)">${kitName}</strong></div>
        <div><div style="font-size:0.7rem;letter-spacing:0.12em;text-transform:uppercase;color:var(--text-light);margin-bottom:4px">Child</div><strong style="color:var(--text-dark)">${cFirst} ${cLast}, age ${cAge}</strong></div>
        <div style="grid-column:1/-1"><div style="font-size:0.7rem;letter-spacing:0.12em;text-transform:uppercase;color:var(--text-light);margin-bottom:4px">Return Address</div><strong style="color:var(--text-dark)">${addr}</strong></div>
        <div style="grid-column:1/-1"><div style="font-size:0.7rem;letter-spacing:0.12em;text-transform:uppercase;color:var(--text-light);margin-bottom:4px">Special People (${people.length})</div><strong style="color:var(--text-dark)">${people.length ? people.join(' · ') : 'None added yet'}</strong></div>
      </div>`;
  }

  function submitForm() {
    const allChecked = document.querySelectorAll('.confirm-check.checked').length === 3;
    if (!allChecked) {
      const checks = document.querySelector('.confirm-checks');
      if (checks) { checks.style.outline = '1.5px solid #BE7F7F'; checks.style.borderRadius = '3px'; }
      return;
    }
    const checks = document.querySelector('.confirm-checks');
    if (checks) checks.style.outline = '';

    // ── SHOPIFY INTEGRATION ──────────────────────────────────
    // Collect all form data and post as cart line item properties.
    // The product "custom-kit-order" must exist in your Shopify store.
    // Uncomment and adapt the block below, or replace with your
    // preferred form backend (Typeform / JotForm / Klaviyo / etc.)
    //
    // const kit = document.querySelector('.kit-option.selected');
    // const formData = new FormData();
    // formData.append('id', YOUR_PRODUCT_VARIANT_ID);
    // formData.append('quantity', 1);
    // formData.append('properties[Parent]', `${document.getElementById('parent-first').value} ${document.getElementById('parent-last').value}`);
    // formData.append('properties[Order #]', document.getElementById('order-number').value);
    // formData.append('properties[Child]', `${document.getElementById('child-first').value} ${document.getElementById('child-last').value}`);
    // formData.append('properties[Kit]', kit?.querySelector('.kit-name')?.textContent || '');
    // fetch('/cart/add.js', { method: 'POST', body: formData });

    // Show success state
    document.querySelectorAll('.form-card').forEach(c => { c.style.display = 'none'; });
    const stepper = document.getElementById('stepper');
    if (stepper) stepper.style.display = 'none';
    const success = document.getElementById('form-success');
    if (success) success.classList.add('visible');
    const formTop = document.getElementById('order-form');
    if (formTop) window.scrollTo({ top: formTop.offsetTop - 80, behavior: 'smooth' });
  }

  return { togglePerson, updatePersonPreview, handlePhoto, goToStep, nextStep, prevStep, submitForm };
})();
